import { useState } from "react";
import { Box, Typography, Grid, Button, Link, Alert } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { LanguageItem, AuthPageLayout } from "../../lib/common";
import AsyncFormBox from "../../lib/common/AsyncFormBox";
import { CommonCalls } from "../../config/calls";
import { UsernameInput } from "../../lib/inputs";

function BackToSignInLink() {
  return (
    <Link component={RouterLink} to={"/signIn"} variant={"body2"}>
      <LanguageItem cs>Zpět na přihlášení</LanguageItem>
      {/* <LanguageItem en>Back to Sign In</LanguageItem> */}
    </Link>
  );
}

function SubmittedFeedback() {
  return (
    <Box sx={{ mt: 3, maxWidth: 400, textAlign: "center" }}>
      <Alert severity="success" sx={{ mb: 2 }}>
        <LanguageItem cs>
          Pokud účet s tímto e-mailem existuje, byl na něj odeslán odkaz pro obnovení hesla.
        </LanguageItem>
        {/* <LanguageItem en>
          If an account with this email exists, a password reset link has been sent.
        </LanguageItem> */}
      </Alert>
      <BackToSignInLink />
    </Box>
  );
}

function ForgotPassword() {
  const [submitted, setSubmitted] = useState(false);

  /**
   * Submits password reset request to the backend.
   * @param {object} values - Form values containing email.
   * @returns {Promise} API call promise.
   */
  function handleSubmit(values) {
    return CommonCalls.resetPassword({
      username: values.email,
      hostUri: window.location.origin,
    });
  }

  /**
   * Handles successful submission by showing a confirmation message.
   */
  function onSubmitDone() {
    setSubmitted(true);
  }

  return (
    <AuthPageLayout
      title={
        <>
          <LanguageItem cs>Zapomenuté heslo</LanguageItem>
          {/* <LanguageItem en>Forgot Password</LanguageItem> */}
        </>
      }>
      {submitted && <SubmittedFeedback />}

      {!submitted && (
        <AsyncFormBox
          onSubmit={handleSubmit}
          onSubmitDone={onSubmitDone}
          boxProps={{
            sx: { mt: 2 },
          }}>
          <Typography variant="body2" sx={{ mb: 1, color: "text.secondary" }}>
            <LanguageItem cs>Zadejte svou e-mailovou adresu a my vám zašleme odkaz pro obnovení hesla.</LanguageItem>
            {/* <LanguageItem en>
              Enter your email address and we will send you a link to reset your password.
            </LanguageItem> */}
          </Typography>
          <UsernameInput margin={"normal"} fullWidth autoFocus />

          <Button type={"submit"} fullWidth variant={"contained"} sx={{ mt: 3, mb: 2 }}>
            <LanguageItem cs>Odeslat odkaz pro obnovení</LanguageItem>
            {/* <LanguageItem en>Send Reset Link</LanguageItem> */}
          </Button>

          <Grid container justifyContent={"flex-end"}>
            <Grid>
              <BackToSignInLink />
            </Grid>
          </Grid>
        </AsyncFormBox>
      )}
    </AuthPageLayout>
  );
}

export default ForgotPassword;
